import { useImmer } from "use-immer";
import { SlotKey } from "../utils/types";
import { SlotType, UseInteractivity } from "./types";
import { noInteractivity } from "./noInteractivity";


export const useHovering : UseInteractivity = ({
  isHoverable = () => true,
  onHover = (start: SlotKey | null) => {},
}) => {
  const [ type, setType ] = useImmer<SlotType| null>(null);
  const [ key, setKey ] = useImmer<SlotKey | null>(null);

  const callbacks = (slotKey: number, type : SlotType = "slot") => ({
    onMouseEnter: () => {
      if(!isHoverable(slotKey)) return;
      setType(type);
      setKey(slotKey)
      onHover(slotKey);
    },
    onMouseLeave: () => {
      setType(null);
      setKey(null)
      onHover(null)
    },
  });

  const isDayHovered = (slotKey: number) => {
    if (!key || type === "time") return false;

    const slotKeyDate = new Date(slotKey);
    const hoveringDate = new Date(key);

    return slotKeyDate.getDay() === hoveringDate.getDay();
  }

  const isTimeHovered = (slotKey: number) => {
    if (!key || type === "day") return false;
    
    const slotKeyDate = new Date(slotKey);
    const hoveringDate = new Date(key);
    return (
      slotKeyDate.getMinutes() === hoveringDate.getMinutes() &&
      slotKeyDate.getHours() === hoveringDate.getHours()
    )
  }

  const isHovered = (slotKey: number, slotType?: SlotType) => {
    if(slotType === "day") return isDayHovered(slotKey);
    if(slotType === "time") return isTimeHovered(slotKey);
    return isDayHovered(slotKey) || isTimeHovered(slotKey);
  }

  return {...noInteractivity, isHovered, callbacks };
}